<template>
    <div class="privacyService">
        <div class="privacy-header flex">
            <div class="privacy-header-item" v-for="(item, index) in carList" :key="index" @click="changeCar(item, index)">
                <p class="privacy-header-code">{{ parseCarCode(item.carNo) }}</p>
                <div v-if="active == index" class="quickPay-code-itemA">
                    <div class="privacy-active-wrap flex-column justify-center align-center">
                        <img src="@/assets/images/pay/car-bg-checked.png" alt="" />
                        <p>{{ parseCarCode(item.carNo) }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="privacy-block"></div>
        <div class="privacy-list">
            <div class="privacy-item flex justify-between align-center">
                <img src="@/assets/images/privacy/privacy-msg.png" alt="" class="privacy-left-img" />
                <div class="privacy-content">
                    <p class="privacy-content-title">不推送该车的车入车出消息给我</p>
                    <p class="privacy-content-desc">开启后，将不会收到该车辆车入车出的消息</p>
                </div>
                <van-switch v-model="activeData.messageSwitch" @change="switchReceiveMsg" :active-value="0" :inactive-value="1" size="20px" />
            </div>
            <div class="privacy-item flex justify-between align-center">
                <img src="@/assets/images/privacy/privacy-prohibit-bind.png" alt="" class="privacy-left-img" />
                <div class="privacy-content">
                    <p class="privacy-content-title">禁止他人绑定</p>
                    <p class="privacy-content-desc">开启后，他人无法绑定该车辆</p>
                </div>
                <van-switch v-model="bindingFlag" disabled :active-value="1" :inactive-value="0" size="20px" />
            </div>
            <div class="privacy-item flex justify-between align-center">
                <img src="@/assets/images/privacy/privacy-msg.png" alt="" class="privacy-left-img" />
                <div class="privacy-content">
                    <p class="privacy-content-title">禁止他人查询欠费</p>
                    <p class="privacy-content-desc">开启后，他人无法查看该车辆的欠费记录以及缴费记录</p>
                </div>
                <van-switch v-model="ArrearFlag" disabled :active-value="1" :inactive-value="0" size="20px" />
            </div>
        </div>
    </div>
</template>

<script>
import { getBindListApi, editCarApi } from "@/api/index";
import { parseCarCode } from "@/libs/parseData";
export default {
    name: "PrivacyService",
    data() {
        return {
            active: 0,
            carList: [],
            activeData: {},
            bindingFlag: 0, //绑定标志  status== 1 才设置为 1 用户不能改
            ArrearFlag: 0, //欠费标志   status== 1 才设置为 1 用户不能改
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        parseCarCode,
        getList() {
            getBindListApi().then((res) => {
                this.carList = res.data;
                if (this.carList.length > 0) {
                    this.changeCar(this.carList[0], 0);
                }
            });
        },
        changeCar(item, index) {
            this.activeData = item;
            this.active = index;
            if (item.status == 1) {
                this.bindingFlag = 1;
                this.ArrearFlag = 1;
            } else {
                this.bindingFlag = 0;
                this.ArrearFlag = 0;
            }
        },
        // 推送出场信息开关修改事件
        switchReceiveMsg() {
            editCarApi({
                id: this.activeData.id,
                messageSwitch: this.activeData.messageSwitch,
            }).then((res) => {
                this.$toast("设置成功!");
            });
        },
    },
};
</script>

<style lang="less" scoped>
.privacyService {
    min-height: 100vh;
    background-color: #fff;

    .privacy-header {
        padding: 28px 0;
        margin-left: 79px;
        overflow-x: scroll;
        .privacy-header-item {
            flex-shrink: 0;
            width: 592px;
            height: 204px;
            background: url("~@/assets/images/privacy/privacy-bg.png") no-repeat;
            background-size: 100% 100%;
            padding: 79px 0 0 119px;
            margin-right: 30px;
            position: relative;
            .privacy-header-code {
                font-size: 48px;
                font-weight: 500;
                color: #ffffff;
            }
            .quickPay-code-itemA {
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                background: #009af3cc;
                border-radius: 8px;
                .privacy-active-wrap {
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    margin: auto;

                    img {
                        width: 48px;
                        height: 48px;
                    }
                    p {
                        color: #fff;
                        font-size: 32px;
                        margin-top: 12px;
                    }
                }
            }
        }
    }
    .privacy-list {
        width: 750px;
        height: 144px;
        .privacy-item {
            border-bottom: 1px solid #dbdada33;
            padding: 30px;
            .privacy-left-img {
                width: 72px;
                height: 72px;
            }
            .privacy-content {
                flex: 1;
                padding: 0 30px;
                .privacy-content-title {
                    font-size: 28px;
                    color: #333333;
                }
                .privacy-content-desc {
                    font-size: 24px;
                    color: #999999;
                }
            }
        }
    }
    .privacy-block {
        width: 100vw;
        height: 16px;
        background: #f5f8fa;
    }
}
</style>
